import { Component } from '@angular/core';
import { CONTACT_INFO } from '../../constants/contact-info';

@Component({
  selector: 'app-home-footer',
  templateUrl: './home-footer.component.html',
  styleUrls: ['./home-footer.component.scss']
})
export class HomeFooterComponent {
  contactInfo = CONTACT_INFO;
}